<template>
  <div class="main user-layout-register">
    <h3><span>注册</span></h3>
    <a-form ref="formRegister" :form="form" id="formRegister">
      <div :style="{ textAlign: 'center' }" v-if="registerType == ''">
        <a-button-group size="large">
          <a-button type="primary" @click="staffRegister">
            <a-icon type="left" />员工注册
          </a-button>
          <a-button type="primary" @click="enterpriseRegister">
            企业注册<a-icon type="right" />
          </a-button>
        </a-button-group>
      </div>
      <div v-if="registerType == '0'">
        <a-form-item>
          <a-input size="large" placeholder="11 位手机号" v-decorator="['phoneNumber', {rules: [{ required: true, message: '请输入正确的手机号', pattern: /^1[3456789]\d{9}$/ }], validateTrigger: ['change', 'blur'] }]"></a-input>
        </a-form-item>
        <a-form-item>
          <a-input size="large" placeholder="注册码" v-decorator="['registrationCode', {rules: [{ required: true, message: '请输入注册码'} ], validateTrigger: ['change', 'blur'] }]"></a-input>
        </a-form-item>
      </div>
      <div v-if="registerType == '1' || registerType == '2'">
        <a-form-item>
          <a-input
            size="large"
            type="text"
            placeholder="用户名"
            v-decorator="['loginName', { rules: [{min:5,max:20,required: true, message: '请输入5-20位字符!'}] , validateTrigger: ['change', 'blur']}]"
          ></a-input>
        </a-form-item>

        <a-popover
          placement="rightTop"
          :trigger="['focus']"
          :getPopupContainer="(trigger) => trigger.parentElement"
          v-model="state.passwordLevelChecked">
          <template slot="content">
            <div :style="{ width: '240px' }" >
              <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
              <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor " />
              <div style="margin-top: 10px;">
                <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
              </div>
            </div>
          </template>
          <a-form-item>
            <a-input
              size="large"
              type="password"
              @click="handlePasswordInputClick"
              autocomplete="false"
              placeholder="至少6位密码，区分大小写"
              v-decorator="['password', {rules: [{ required: true, message: '至少6位密码，区分大小写'}, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur']}]"
            ></a-input>
          </a-form-item>
        </a-popover>

        <a-form-item>
          <a-input
            size="large"
            type="password"
            autocomplete="false"
            placeholder="确认密码"
            v-decorator="['password2', {rules: [{ required: true, message: '至少6位密码，区分大小写' }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur']}]"
          ></a-input>
        </a-form-item>

        <a-form-item>
          <a-input size="large" placeholder="姓名" v-decorator="['userName', {rules: [{ required: true, message: '请输入姓名'} ], validateTrigger: ['change', 'blur'] }]"></a-input>
        </a-form-item>

        <a-form-item>
          <a-input size="large" placeholder="11 位手机号" :disabled="isAble"  v-decorator="['phone', {rules: [{ required: true, message: '请输入正确的手机号', pattern: /^1[3456789]\d{9}$/ }], validateTrigger: ['change', 'blur'] }]"></a-input>
        </a-form-item>
      </div>

      <div v-if="registerType == '2'">
        <a-form-item>
          <a-input size="large" placeholder="备用联系方式" v-decorator="['contactReserve', {rules: [{ required: false, message: '请输入正确的手机号', pattern: /^1[3456789]\d{9}$/ } ], validateTrigger: ['change', 'blur'] }]"></a-input>
        </a-form-item>
        <a-row :gutter="16">
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-select placeholder="性别" :allowClear="true" v-decorator="['sex']">
                <a-select-option value="0">
                  男
                </a-select-option>
                <a-select-option value="1">
                  女
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-input size="large" placeholder="部门" v-decorator="['registerDept', {rules: [{ required: true, message: '请输入部门'} ], validateTrigger: ['change', 'blur'] }]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-input size="large" placeholder="职位" v-decorator="['registerRole', {rules: [{ required: true, message: '请输入职位'} ], validateTrigger: ['change', 'blur'] }]"></a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-date-picker placeholder="入职时间" v-decorator="['entryTime']" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-select placeholder="省" :allowClear="true" :options="provinceMap" @change="changeProvince" v-decorator="['provinceId']"></a-select>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-select placeholder="市" :allowClear="true" :options="cityMap" @change="changeCity" v-decorator="['cityId']"></a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-select placeholder="区" :allowClear="true" :options="areaArr" v-decorator="['districtId']"></a-select>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-input size="large" placeholder="详细地址" v-decorator="['detailedAddress']"></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-input size="large" placeholder="紧急联系人" v-decorator="['emergencyContact']"></a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-input size="large" placeholder="紧急联系人电话" v-decorator="['linkmanPhonenumber']"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <div v-if="registerType == '1'">
        <h3><span>企业信息</span></h3>
        <a-row :gutter="16">
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-input size="large" placeholder="企业名称" v-decorator="['enterpriseName', {rules: [{ required: true, message: '请输入企业名称'} ], validateTrigger: ['change', 'blur'] }]"></a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-input size="large" placeholder="企业简称" v-decorator="['enterpriseSysName', {rules: [{ required: true, message: '请输入企业简称'} ], validateTrigger: ['change', 'blur'] }]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-input size="large" placeholder="注册人" v-decorator="['register', {rules: [{ required: true, message: '请输入注册人'} ], validateTrigger: ['change', 'blur'] }]"></a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="12">
            <a-form-item>
              <a-input size="large" placeholder="联系方式" v-decorator="['registerPhone', {rules: [{ required: true, message: '请输入正确的手机号', pattern: /^1[3456789]\d{9}$/ }, { validator: this.handlePhoneCheck } ], validateTrigger: ['change', 'blur'] }]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col class="gutter-row" :span="24">
            <a-form-item>
              <h4><span>安装类别</span></h4>
              <a-checkbox-group :options="installTypeMap" v-decorator="['installTypes', {rules: [{ required: true, message: '请选择安装类型'} ], validateTrigger: ['change', 'blur'] }]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-form-item>
            <a-select style="width: 95%" placeholder="默认安装类别" :options="installTypeMap" v-decorator="['defaultInstallType', {rules: [{ required: true, message: '请选择默认安装类型'} ], validateTrigger: ['change', 'blur'] }]" />
          </a-form-item>
        </a-row>
      </div>

      <a-form-item>
        <a-button
          v-if="registerType == '1' || registerType == '2'"
          size="large"
          type="primary"
          htmlType="submit"
          class="register-button"
          :loading="registerBtn"
          @click="handleSubmit"
          :disabled="registerBtn">提交
        </a-button>
        <a-button
          v-if="registerType == '0'"
          size="large"
          type="primary"
          htmlType="submit"
          class="register-button"
          @click="verification">提交
        </a-button>
        <router-link class="login" :to="{ name: 'login' }">使用已有账户登录</router-link>
      </a-form-item>

    </a-form>
  </div>
</template>

<script>
  import { mixinDevice } from '@/utils/mixin.js'
  import { getselectAllProvince, getselectCityName, getselectAreaName } from '@/api/enterprise/enterprise'
  import { getInstallType, registrationCode, addEmployee, addEnterprise } from '../../api/login'

  const levelNames = {
    0: '低',
    1: '低',
    2: '中',
    3: '强'
  }
  const levelClass = {
    0: 'error',
    1: 'error',
    2: 'warning',
    3: 'success'
  }
  const levelColor = {
    0: '#ff0000',
    1: '#ff0000',
    2: '#ff7e05',
    3: '#52c41a'
  }
  export default {
    name: 'Register',
    components: {
    },
    mixins: [mixinDevice],
    data () {
      return {
        form: this.$form.createForm(this),

        state: {
          time: 60,
          smsSendBtn: false,
          passwordLevel: 0,
          passwordLevelChecked: false,
          percent: 10,
          progressColor: '#FF0000'
        },
        registerBtn: false,
        provinceMap: [],
        cityMap: [],
        areaArr: [],
        installTypeMap: [],
        registerType: '',
        isAble: false,
        phone: undefined
      }
    },
    computed: {
      passwordLevelClass () {
        return levelClass[this.state.passwordLevel]
      },
      passwordLevelName () {
        return levelNames[this.state.passwordLevel]
      },
      passwordLevelColor () {
        return levelColor[this.state.passwordLevel]
      }
    },
    async created () {
      this.form.resetFields()
      // 省
      await getselectAllProvince().then(res => {
        if (res.code === 0) {
          res.rows.forEach(province => {
            this.provinceMap.push({ value: province.provinceCode, label: province.provinceName })
          })
        }
      })

      // 安装类型
      this.installTypeArr = await getInstallType('install_type')
      this.installTypeArr.rows.forEach(data => {
        this.installTypeMap.push(
          { value: data.dictValue, label: data.dictLabel }
        )
      })
    },
    methods: {

      handlePasswordLevel (rule, value, callback) {
        let level = 0

        // 判断这个字符串中有没有数字
        if (/[0-9]/.test(value)) {
          level++
        }
        // 判断字符串中有没有字母
        if (/[a-zA-Z]/.test(value)) {
          level++
        }
        // 判断字符串中有没有特殊符号
        if (/[^0-9a-zA-Z_]/.test(value)) {
          level++
        }
        this.state.passwordLevel = level
        this.state.percent = level * 30
        if (level >= 2) {
          if (level >= 3) {
            this.state.percent = 100
          }
          callback()
        } else {
          if (level === 0) {
            this.state.percent = 10
          }
          callback(new Error('密码强度不够'))
        }
      },
      handlePasswordCheck (rule, value, callback) {
        const password = this.form.getFieldValue('password')
        console.log('value', value)
        if (value === undefined) {
          callback(new Error('请输入密码'))
        }
        if (value && password && value.trim() !== password.trim()) {
          callback(new Error('两次密码不一致'))
        }
        callback()
      },

      handlePhoneCheck (rule, value, callback) {
        console.log('handlePhoneCheck, rule:', rule)
        console.log('handlePhoneCheck, value', value)
        console.log('handlePhoneCheck, callback', callback)

        callback()
      },

      handlePasswordInputClick () {
        if (!this.isMobile()) {
          this.state.passwordLevelChecked = true
          return
        }
        this.state.passwordLevelChecked = false
      },
      changeProvince (e) {
        this.cityMap = []
        this.areaArr = []
        this.form.setFieldsValue({
          cityId: '',
          districtId: ''
        })
        // 市
        this.province = { provinceCode: e }
        getselectCityName(this.province).then(res => {
          if (res.code === 0) {
            res.rows.forEach(city => {
              this.cityMap.push({ value: city.cityCode, label: city.cityName })
            })
          }
        })
      },
      changeCity (e) {
        this.areaArr = []
        this.form.setFieldsValue({
          districtId: ''
        })
        // 区
        this.city = { cityCode: e }
        getselectAreaName(this.city).then(res => {
          if (res.code === 0) {
            res.rows.forEach(area => {
              this.areaArr.push({ value: area.areaCode, label: area.areaName })
            })
          }
        })
      },
      staffRegister () {
        this.registerType = '0'
      },
      enterpriseRegister () {
        this.registerType = '1'
        this.form.resetFields()
      },
      verification () {
        this.form.validateFields((err, values) => {
          if (!err) {
            registrationCode(values).then(res => {
              if (res.code === 0) {
                this.$message.success('验证成功')
                this.registerType = '2'
                this.isAble = true
                this.$nextTick(() => {
                  this.form.setFieldsValue({
                    phone: values.phoneNumber
                  })
                })
              }
              if (res.code === 500) {
                this.$message.error(res.msg)
              }
            }).catch(res => {
              this.$message.error(res.msg)
            })
          }
        })
      },
      handleSubmit () {
        this.form.validateFields((err, values) => {
          if (!err) {
            // 新员工注册
            if (this.registerType === '2') {
              if(values['entryTime'] !== null && values['entryTime'] !== undefined && values['entryTime'] !== ''){
                values['entryTime'] = values['entryTime'].format('YYYY-MM-DD')
              }
              addEmployee(values).then(res => {
                if (res.code === 0) {
                  this.$message.success('注册成功')
                  this.$router.push({ name: 'login' })
                }
                if (res.code === 500) {
                  this.$message.error(res.msg)
                }
              })
            }

            // 企业注册
            if (this.registerType === '1') {
              addEnterprise(values).then(res => {
                if (res.code === 0) {
                  this.$message.success('注册成功')
                  this.$router.push({ name: 'login' })
                }
                if (res.code === 500) {
                  this.$message.error(res.msg)
                }
              })
            }
          }
        })
      },
      requestFailed (err) {
        this.$notification['error']({
          message: '错误',
          description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
          duration: 4
        })
        this.registerBtn = false
      }
    },
    watch: {
      'state.passwordLevel' (val) {
        console.log(val)
      }
    }
  }
</script>
<style lang="less">
  .user-register {

    &.error {
      color: #ff0000;
    }

    &.warning {
      color: #ff7e05;
    }

    &.success {
      color: #52c41a;
    }

  }

  .user-layout-register {
    .ant-input-group-addon:first-child {
      background-color: #fff;
    }
  }
</style>
<style lang="less" scoped>
  .user-layout-register {

    & > h3 {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

    .register-button {
      width: 50%;
    }

    .login {
      float: right;
      line-height: 40px;
    }
  }
</style>
